<template>
  <div class="text-left">
        <v-card>
          <v-form class="pa-6" ref="form">
            <v-row>
              <v-col cols="12">
                <h3 class="text-left">{{ $t("title.researchAreaData") }}</h3>
              </v-col>
            </v-row>

            <h5>
              {{ $t("form.name") }}
            </h5>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-text-field
                  v-model="research_area.name.es"
                  :label="$t('form.es')"
                  required
                  outlined
                  :rules="rules.char_required_max_55"
                  :counter="55"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-text-field
                  v-model="research_area.name.gl"
                  :label="$t('form.gl')"
                  required
                  outlined
                  :rules="rules.char_required_max_55"
                  :counter="55"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-text-field
                  v-model="research_area.name.en"
                  :label="$t('form.en')"
                  required
                  outlined
                  :rules="rules.char_required_max_55"
                  :counter="55"
                ></v-text-field>
              </v-col>
            </v-row>
            <h5>
              {{ $t("form.description") }}
            </h5>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-tabs v-model="tab_description">
                  <v-tab
                    class="capitalize"
                    v-for="(item, index) in Object.keys(
                      research_area.description
                    )"
                    :key="index"
                  >
                    {{ $t("form." + item) }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab_description">
                  <v-tab-item
                    class="mt-2"
                    v-for="(item, index) in Object.keys(
                      research_area.description
                    )"
                    :key="index"
                  >
                    <EditorText
                      :key="item"
                      :text="research_area.description[item]"
                      :language="item"
                      field="description"
                      @change-content="changeContent"
                    />
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
            <h5>
              {{ $t("form.researchArea.image") }}
            </h5>
            <UploadImage
              :path="$store.state.endpoint + '/researchArea/' + research_area.id"
              :url="$store.state.endpoint + research_area.image"
              :object="{ name: research_area.image }"
              :object_created="research_area.id !== undefined"
              name_field="image"
            />
            <h5>
              {{ $t("form.researchArea.image_squared") }}
            </h5>
            <UploadImage
              :path="$store.state.endpoint + '/researchArea/' + research_area.id"
              :url="$store.state.endpoint + research_area.image_squared"
              :object="{ name: research_area.image_squared }"
              :object_created="research_area.id !== undefined"
              name_field="image_squared"
            />
            <h5>
              {{ $t("form.researchArea.objectives_scientific") }}
            </h5>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-tabs v-model="tab_scientific">
                  <v-tab
                    class="capitalize"
                    v-for="(item, index) in Object.keys(
                      research_area.objectives_scientific
                    )"
                    :key="index"
                  >
                    {{ $t("form." + item) }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab_scientific">
                  <v-tab-item
                    class="mt-2"
                    v-for="(item, index) in Object.keys(
                      research_area.objectives_scientific
                    )"
                    :key="index"
                  >
                    <EditorText
                      :key="item"
                      :text="research_area.objectives_scientific[item]"
                      :language="item"
                      field="objectives_scientific"
                      @change-content="changeContent"
                    />
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
            <h5>
              {{ $t("form.researchArea.objectives_technologic") }}
            </h5>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-tabs v-model="tab_technologic">
                  <v-tab
                    class="capitalize"
                    v-for="(item, index) in Object.keys(
                      research_area.objectives_technologic
                    )"
                    :key="index"
                  >
                    {{ $t("form." + item) }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab_technologic">
                  <v-tab-item
                    class="mt-2"
                    v-for="(item, index) in Object.keys(
                      research_area.objectives_technologic
                    )"
                    :key="index"
                  >
                    <EditorText
                      :key="item"
                      :text="research_area.objectives_technologic[item]"
                      :language="item"
                      field="objectives_technologic"
                      @change-content="changeContent"
                    />
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
            <h5>
              {{ $t("form.researchArea.marketing_slogan") }}
            </h5>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-tabs v-model="tab_slogan">
                  <v-tab
                    class="capitalize"
                    v-for="(item, index) in Object.keys(
                      research_area.marketing_slogan
                    )"
                    :key="index"
                  >
                    {{ $t("form." + item) }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab_slogan">
                  <v-tab-item
                    class="mt-2"
                    v-for="(item, index) in Object.keys(
                      research_area.marketing_slogan
                    )"
                    :key="index"
                  >
                    <EditorText
                      :key="item"
                      :text="research_area.marketing_slogan[item]"
                      :language="item"
                      field="marketing_slogan"
                      @change-content="changeContent"
                    />
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
            <h5>
              {{ $t("form.researchArea.contacts") }}
            </h5>
            <SelectPeopleList :items-selected="contacts" />
            <v-row>
              <v-col cols="6" sm="3">
                <v-checkbox
                  v-model="research_area.closed"
                  :label="$t('form.researchArea.closed')"
                ></v-checkbox>
              </v-col>
              <v-col cols="6" sm="3">
                <v-checkbox
                  v-model="research_area.deprecated"
                  :label="$t('form.researchArea.deprecated')"
                ></v-checkbox>
              </v-col>
              <v-col cols="6" sm="3" >
                <v-checkbox
                  v-model="research_area.hidden"
                  :label="$t('form.hidden')"
                ></v-checkbox>
              </v-col>
              <v-col cols="6" sm="3">
                <v-checkbox
                  v-model="research_area.featured"
                  :label="$t('form.featured')"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-divider />
            <div class="text-center">
              <v-btn text @click="$router.back()"><v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}</v-btn>
              <v-btn color="primary" @click="save" class="ml-2"><v-icon left>mdi-content-save</v-icon>{{ $t("button.save") }}</v-btn>
            </div>
          </v-form>
        </v-card>
  </div>
</template>

<script>
import axios from "axios";
import validationRules from "../../mixins/validationRules";
import EditorText from "../../components/reusables/EditorText";
import SelectPeopleList from "../../components/reusables/SelectPeopleList";
import UploadImage from "../../components/layouts/UploadImage";
export default {
  components: { EditorText, SelectPeopleList, UploadImage },
  mixins: [validationRules],
  name: "EditResearchAreaDetail",
  data: () => ({
    tab_description: null,
    tab_scientific: null,
    tab_technologic: null,
    tab_slogan: null,
    contacts: [],
    image_url: "",
    image_squared_url: "",
    image_max_height: 300,
    image_max_with: 500,
    research_area: {
      name: { es: "", en: "", gl: "" },
      description: { es: "", en: "", gl: "" },
      objectives_scientific: { es: "", en: "", gl: "" },
      objectives_technologic: { es: "", en: "", gl: "" },
      marketing_slogan: { es: "", en: "", gl: "" },
      deprecated: false,
      image: null,
      image_squared: null,
      closed: false,
      hidden: false,
      featured: false,
      contacts: []
    }
  }),

  created() {
    if (this.$route.params.id > -1) {
      this.getResearchArea();
    } else {
      this.initializeForm();
    }
  },

  computed: {
    processData() {
      let data = {
        name: this.research_area.name,
        description: this.research_area.description,
        objectives_scientific: this.research_area.objectives_scientific,
        objectives_technologic: this.research_area.objectives_technologic,
        marketing_slogan: this.research_area.marketing_slogan,
        deprecated: this.research_area.deprecated,
        closed: this.research_area.closed,
        hidden: this.research_area.hidden,
        featured: this.research_area.featured,
        contacts: this.contacts
          .filter(item => item.id != null)
          .map(function(item) {
            return item.id;
          })
      };
      return data;
    }
  },

  methods: {
    preview_image(file) {
      console.log("previewing image", file);
      if (file !== undefined) {
        this.image_url = URL.createObjectURL(file);
      } else {
        this.image_url = null;
      }
    },
    preview_image_squared(file) {
      if (file !== undefined) {
        this.image_squared_url = URL.createObjectURL(file);
      } else {
        this.image_squared_url = null;
      }
    },
    initializeForm() {},

    changeContent(lan, content, field) {
      this.research_area[field][lan] = content;
    },

    getResearchArea() {
      let path =
        this.$store.state.endpoint + "/researchArea/" + this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.research_area = response.data;
          this.url = this.$store.state.endpoint + this.research_area.image;
        })
        .finally(() => this.getContacts())
        .catch(error => {
          console.log(error);
        });
    },
    getContacts() {
      this.research_area.contacts.forEach(contact => {
        this.contacts.push({
          id: contact.id,
          name: contact.preferred_name.given_name
        });
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        let path;
        if (this.$route.params.id > -1) {
          path =
            this.$store.state.endpoint +
            "/researchArea/" +
            this.$route.params.id;
          axios
            .patch(path, this.processData)
            .then(() => {
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.updateItem")
              });
              this.saveImage(this.$route.params.id);
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        } else {
          path = this.$store.state.endpoint + "/researchArea";
          axios
            .post(path, this.processData)
            .then(response => {
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.createItem")
              });
              this.saveImage(response.data.id);
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        }
      }
    },
    saveImage(id) {
      if (typeof this.research_area.image !== "string") {
        let formData;
        if (
          this.research_area.image !== undefined &&
          this.research_area.image !== null
        ) {
          formData = new FormData();
          formData.append("image", this.research_area.image);
        } else {
          formData = { image: null };
        }

        const path = this.$store.state.endpoint + "/researchArea/" + id;
        axios
          .patch(path, formData)
          .then(() => {
            this.$router.push("/manage/edit/researchAreas");
          })
          .catch(error => {
            console.log(error);
            this.$store.commit("alert", {
              color: "error",
              text: error.response.data
            });
          });
      } else {
        this.$router.push("/manage/edit/researchAreas");
      }
    }
  }
};
</script>
